function UserAccount(data) {

    var self = this;

    if (typeof data === "undefined" || data === null) {
        return null;
    }

    // Private Variables
    var timeoutUnconfirmedPoll = 0;

    // Public Variables
    self.id = data.accountId;

    self.hasTrialEnded = data.hasTrialEnded;
    self.isDirectSale = data.isDirectSale;
    self.isConfirmed = data.isConfirmed;
    self.hasSubscription = data.hasSubscription;
    self.partnerId = data.partnerId;
    self.partnerDisplayName = data.partnerDisplayName;
    self.partnerIncursUSTax = data.partnerIncursUSTax;

    // Observables
    self.organizationName = ko.observable(data.organizationName);
    self.computerCount = ko.observable(data.computerCount);
    self.complimentaryComputers = data.complimentaryComputerCount;
    self.maxComputers = ko.observable(data.maxComputers);
    self.unconfirmedEndpointCount = ko.observable(data.unconfirmedEndpointCount);
    self.showHeaderDropDown = ko.observable(false);

    // Computeds
    self.isUnconfirmedEndpointMessageVisible = ko.computed(function() {
        return self.unconfirmedEndpointCount() >= 1;
    });

    self.percentComputersUsed = ko.computed(function() {
        return (self.computerCount() / self.maxComputers()) * 100;
    });

    self.computerUsedBarlength = ko.computed(function() {
        var barWidth = 200;
        var maxCount = self.maxComputers();

        if (maxCount === 0) return barWidth;

        return Math.ceil((Math.min(self.computerCount(), self.maxComputers()) / maxCount) * barWidth).toString() + "px";
    });

    self.isComputersLimitReached = ko.computed(function() {
        return self.computerCount() >= self.maxComputers();
    });

    
    //Event Handlers
    self.reviewUnconfirmedEndpointsClick = function () {
        cccApp.closePopup();

        cccApp.api.post({
            url: "service/accounts/checkAccess",
            success: function () {
                loadPopup(ko, "review-unconfirmedendpoints-popup", {}, null);
            },
            error: function (error) {
                if (error && error.code === cccApp.api.codes.ERR_UserAccessDeniedTrayLogin) {
                    logActivity("User Access Denied",
                    {
                        "url": "review-unconfirmedendpoints-popup",
                        "userDisplayName": cccApp.user.displayName()
                    });

                    cccApp.ui.closeUserMenu();
                    loadPopup(ko, "login-popup", null, null, true);
                }
            }
        });
    };

    //Public Functions
    self.init = function () {
        if (self.isConfirmed) {
            self.startUnconfirmedEndpointPoll();
        }
    };

    self.refreshMaxComputers = function(subscribedComputers) {
        self.maxComputers(subscribedComputers + self.complimentaryComputers);
    };

    self.refreshUnconfirmedEndpointCount = function() {
        getUnconfirmedEndpointCount();
    };

    self.startUnconfirmedEndpointPoll = function() {
        self.stopUnconfirmedEndpointPoll();
        timeoutUnconfirmedPoll = setTimeout(getUnconfirmedEndpointCount, 15000);
    };

    self.stopUnconfirmedEndpointPoll = function() {
        clearTimeout(timeoutUnconfirmedPoll);
    };

    // API Calls
    function getUnconfirmedEndpointCount() {
        var url = "service/accounts/unconfirmedendpointcount";
        self.stopUnconfirmedEndpointPoll();
        cccApp.api.get({
            url: url,
            global: false,
            queueKey: "account-unconfirmedendpointcount-poll",
            errorMessage: "Sorry, there was an error checking for new endpoints",
            success: function (results) {
                if (!results.error && typeof results.data === "number") {
                    self.unconfirmedEndpointCount(results.data);
                } else if (results.error) {
                    cccApp.msg.error(results.error);
                } else {
                    cccApp.msg.error(this.errorMessage);
                }
                self.startUnconfirmedEndpointPoll();
            },
            error: function (err) {
                if (err.code !== cccApp.api.codes.ERR_UserAccessDenied) {
                    self.startUnconfirmedEndpointPoll();
                }
            }
        });
    }

    return self;
}